var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuCuratorshipAssertivinessBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#660099;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.3,135.8h242.1c7.8,0,14.2-6.4,14.2-14.2s-6.4-14.2-14.2-14.2H96.3c-7.8,0-14.2,6.4-14.2,14.2 S88.5,135.8,96.3,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.3,221.9h242.1c7.8,0,14.2-6.4,14.2-14.2s-6.4-14.2-14.2-14.2H96.3c-7.8,0-14.2,6.4-14.2,14.2 S88.5,221.9,96.3,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,243.4c-0.1-13-5.2-25.5-14.4-34.8c-12.9-12.9-33.7-18.6-52.4-10.9V97.5c0-60.3-35.5-96.3-94.9-96.3H94.9 C35.5,1.2,0,37.2,0,97.5v306.6c0,28.9,7.9,51.9,23.5,68.4c16.6,17.6,40.6,26.4,71.3,26.4h243.5c30.7,0,54.7-8.9,71.3-26.4 c15.6-16.5,23.5-39.6,23.5-68.4v-78.6c0-0.5,0-1-0.1-1.5c26.4-23.5,48.9-43.7,52.3-46.9C494.9,267.6,499.9,256,500,243.4z  M404.8,404.1c0,44.1-22.4,66.5-66.5,66.5H94.9c-44.1,0-66.5-22.4-66.5-66.5V97.5c0-21.6,5.4-38.3,16-49.8 c11.1-12.1,28.1-18.2,50.6-18.2h243.5c22.5,0,39.5,6.1,50.6,18.2c10.6,11.5,16,28.2,16,49.8v122.3c-14.6,13.1-40,35.7-67.3,59.9 H96.3c-7.8,0-14.2,6.4-14.2,14.2c0,7.8,6.4,14.2,14.2,14.2h209.2c-11.5,10.2-22.7,20.1-32.9,29.1c-1.8,1.6-3.3,3.8-4,6.1l-7.6,22.5 H96.3c-7.8,0-14.2,6.4-14.2,14.2c0,7.8,6.4,14.2,14.2,14.2h155.2l-7.3,21.6c-0.5,1.5-0.7,3-0.7,4.5c0,7.9,6.4,14.2,14.2,14.2 c1.5,0,3-0.3,4.4-0.7l72.7-24c1.8-0.6,3.5-1.6,5-2.8c6.3-5.6,34.9-30.9,65.2-57.7V404.1z M465.6,256.9 c-5.7,5.7-87.6,78.2-142.5,126.8l-43,14.2l14.1-42c23.1-20.4,135.2-119.4,143.1-127.2c11.6-11.6,24.4-4,28.4,0 c3.8,4,6,9.2,6.1,14.7C471.8,248.3,469.7,252.8,465.6,256.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuCuratorshipAssertivinessBlue);
export default __webpack_public_path__ + "static/media/ic-menu-curatorship-assertiviness-blue.e346f681f748dc97fb2c95c4a78648ef.svg";
export { ForwardRef as ReactComponent };